<template>
  <div style="padding: 10px" class="mt-5 mb-5">
    <v-row class="mb-2">
      <!-- Left: Header info -->
      <v-col cols="12" md="4">
        <v-card style="border-radius: 12px" height="100%">
          <v-card-text>
            <v-list-item class="grow">
              <v-list-item-content>
                <v-list-item-title class="mb-0 mt-0">
                  <span
                    :class="{
                      'text-h4': $vuetify.breakpoint.mdAndUp,
                      'text-h5': $vuetify.breakpoint.smOnly,
                      'text-h6': $vuetify.breakpoint.xsOnly,
                    }"
                    class="mt-0 mb-0 font-weight-bold"
                  >
                    <v-icon :large="$vuetify.breakpoint.mdAndUp" class="mr-2"
                      >mdi-file-upload-outline</v-icon
                    >
                    Check status of uploaded academic service activities
                  </span>
                </v-list-item-title>
                <v-list-item-subtitle class="ml-10 text--disabled"
                  >&nbsp;&nbsp;Support By
                  <i class="text--disabled"
                    >Academic Services Group (กลุ่มบริการวิชาการ)</i
                  ></v-list-item-subtitle
                >

                <v-list-item-title class="ml-10 text--disabled"
                  >&nbsp;&nbsp;Office phone : 02-700-5000 ext. 1241, 1211
                </v-list-item-title>

                <v-list-item-title class="ml-10 mt-5 mb-0">
                  <v-autocomplete
                    :items="years"
                    v-model="selectYear"
                    dense
                    label="Summary by year"
                    filled
                    persistent-hint
                    hint=""
                  ></v-autocomplete>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Right: Summary -->
      <v-col cols="12" md="8">
        <v-card class="mx-auto" height="100%" style="border-radius: 12px">
          <v-card-text>
            <div class="mb-3">
              <span
                :class="{
                  'text-h4': $vuetify.breakpoint.mdAndUp,
                  'text-h5': $vuetify.breakpoint.smOnly,
                  'text-h6': $vuetify.breakpoint.xsOnly,
                }"
                class="font-weight-bold"
              >
                <v-icon :large="$vuetify.breakpoint.mdAndUp" class="mr-2"
                  >mdi-speedometer</v-icon
                >
                Summary
              </span>
            </div>
            <small class="text-small mt-2 mb-0 text--primary"
              >The summary is calculated from the tasks that have been
              <v-chip filter dense small color="green" label class="white--text"
                >Approved</v-chip
              >
              by the authorized personnel.</small
            >
            <div class="mt-5">
              <v-row>
                <v-col
                  v-for="n in summaryReportView"
                  :key="n.labelView"
                  cols="12"
                  md="4"
                >
                  <div class="summary-stat-card">
                    <div class="summary-icon-wrap" :class="n.bgClass">
                      <v-icon :color="n.iconColor" size="24">{{
                        n.icon
                      }}</v-icon>
                    </div>
                    <div class="summary-info">
                      <span class="summary-label">{{ n.labelView }}</span>
                      <span class="summary-value">{{ n.SumView }}</span>
                    </div>
                    <div class="summary-remark">
                      <small class="text--disabled">{{ n.remarkView }}</small>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row gutters>
      <v-col cols="12" md="4">
        <div class="">
          <graphBarReport
            :activityTypes="optionActivityType"
            :activityList="dataAcademic"
          />
        </div>
      </v-col>
      <v-col cols="12" md="8">
        <v-card class="mx-auto" outlined style="border-radius: 12px">
          <v-data-table
            no-data-text="No information"
            loading-text="loading data Academic service activities"
            :loading="loading"
            :headers="headersMain"
            :items="dataAcademic"
            :search="search"
            :items-per-page="10"
            :footer-props="{ 'items-per-page-options': [5, 10, 20, 50, -1] }"
            class="elevation-1"
          >
            <template v-slot:item.status="{ item }">
              <v-chip
                :color="getStatusColor(item.status)"
                small
                dark
                label
                class="text-capitalize font-weight-bold"
              >
                {{ item.status === "send" ? `sent` : item.status }}
              </v-chip>
            </template>
            <template v-slot:item.name_academic="{ item }">
              <div class="text-left">
                <p style="font-weight: 800; font-size: 14px" class="mt-2 mb-2">
                  {{ item.name_academic }}
                </p>
                <div>
                  <strong>Start:</strong>&nbsp;&nbsp;{{
                    formatDate(item.date_start)
                  }}
                </div>
                <div class="d-flex align-center mt-1">
                  <strong>End:</strong>&nbsp;&nbsp;
                  <v-chip
                    x-small
                    label
                    color="purple lighten-5"
                    text-color="purple darken-3"
                    class="font-weight-bold"
                  >
                    {{ formatDate(item.date_end) }}
                  </v-chip>
                </div>
                <div class="mt-1">
                  <strong>Year:</strong>&nbsp;&nbsp;{{
                    getAcademicYear(item.date_start)
                  }}
                </div>
                <div class="d-flex align-center mt-1 mb-2">
                  <strong>PA Year:</strong>&nbsp;&nbsp;
                  <v-chip
                    x-small
                    label
                    color="blue-grey lighten-5"
                    text-color="blue-grey darken-3"
                    class="font-weight-bold"
                  >
                    {{ getPAYearLabel(item.date_end) }}
                  </v-chip>
                </div>
              </div>
            </template>
            <template v-slot:item.activityTy="{ item }">
              <div
                class="text-left"
                v-if="!['', null, 'null'].includes(item.activity_type)"
              >
                <p style="font-size: 14px" class="mt-2 mb-2">
                  {{ item.activity_type_detail.detail }}
                </p>
                <p style="font-size: 14px" class="mt-2 mb-2">
                  {{ item.activity_other }}
                </p>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                small
                color="primary"
                text
                class="text-capitalize font-weight-bold"
                @click="openDetail(item)"
              >
                <v-icon left>mdi-information-outline</v-icon> More Detail
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-navigation-drawer
      v-model="showDetail"
      right
      temporary
      fixed
      :width="$vuetify.breakpoint.mdAndUp ? '1000' : '100%'"
    >
      <v-sheet class="pa-4" color="grey lighten-4" height="100%">
        <v-toolbar flat dense>
          <v-toolbar-title class="font-weight-bold"
            >Activity Detail</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDetail">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider class="mb-3"></v-divider>

        <div v-if="Object.keys(selectedActivity).length != 0">
          <!-- switch component by status -->
          <component
            v-if="selectedActivity && selectedActivity.status"
            :is="resolveComponent"
            :activity="selectedActivity"
            @updatedActivity="onUpdatedActivity"
            @deleteActivity="deleteActivity"
          />
          <div v-else class="text-center grey--text mt-5">
            <v-icon large class="mb-2">mdi-information-outline</v-icon>
            <div>No activity selected</div>
          </div>
        </div>

        <!--  
                    <v-list dense>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold">Status:</v-list-item-title>
                                <v-list-item-subtitle>
                                    <v-chip :color="getStatusColor(selectedActivity.status)" small dark label
                                        class="text-capitalize font-weight-bold">
                                        {{ selectedActivity.status }}
                                    </v-chip>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold">Title:</v-list-item-title>
                                <v-list-item-subtitle style="font-size: 16px;" class="mt-3">{{
                                    selectedActivity.name_academic
                                    }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold">Type:</v-list-item-title>
                                <v-list-item-subtitle style="font-size: 16px;" class="mt-3">{{
                                    selectedActivity.activity_type_detail.detail }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold">Organizer:</v-list-item-title>
                                <v-list-item-subtitle style="font-size: 16px;" class="mt-3">{{
                                    selectedActivity.organizer_record
                                    }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold">Sector:</v-list-item-title>
                                <v-list-item-subtitle style="font-size: 16px;" class="mt-3">{{ selectedActivity.sector
                                    }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold">Date:</v-list-item-title>
                                <v-list-item-subtitle style="font-size: 16px;" class="mt-3">
                                    {{ selectedActivity.date_start }} - {{ selectedActivity.date_end }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold">Hours:</v-list-item-title>
                                <v-list-item-subtitle style="font-size: 16px;" class="mt-3">{{
                                    selectedActivity.hour_activity }}
                                    ชั่วโมง</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold">File:</v-list-item-title>
                                <v-list-item-subtitle>
                                    <v-list subheader two-line>
                                        <v-list-item v-for="folder in selectedActivity.files" :key="folder.title">
                                            <v-list-item-avatar>
                                                <v-icon class="grey lighten-1" dark>
                                                    mdi-folder
                                                </v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <a target="_blank" :href="folder.file">Click Here</a>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action v-if="['save', 'reject'].includes(selectedActivity.status)">
                                                <v-btn icon>
                                                    <v-icon color="red darken-1">mdi-delete-empty</v-icon>
                                                </v-btn>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider class="my-2"></v-divider>
                        <div class="mt-5 mb-0">
                            <v-alert text outlined :color="getStatusAction(`${selectedActivity.status}`)[0]"
                                :icon="getStatusAction(`${selectedActivity.status}`)[1]">
                                <v-list-item
                                    v-if="['save', 'send', 'approve', 'reject'].includes(selectedActivity.status)">
                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-bold">Remark:</v-list-item-title>
                                        <v-list-item-subtitle style="font-size: 16px;" class="mt-3">{{  [null,'null',''].includes(selectedActivity.status_remark) ? `-` : selectedActivity.status_remark }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="['approve'].includes(selectedActivity.status)">
                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-bold">Point:</v-list-item-title>
                                        <p style="font-size: 28px;font-weight: 900;" class="mt-3 mb-0" >{{ selectedActivity.point_activity }}</p>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-alert>
                        </div>
                    </v-list>
                    <div v-else class="text-center grey--text mt-5">
                        <v-icon large class="mb-2">mdi-information-outline</v-icon>
                        <div>No activity selected</div>
                    </div>
                    <div class="text-center">
                        <v-btn
                            v-if="['save'].includes(selectedActivity.status)"
                            :loading="loading3"
                            :disabled="loading3"
                            color="purple darken-3"
                            class="ma-2 white--text"
                            @click="loader = 'loading3'"
                        >
                            Submit
                            <v-icon
                                right
                                dark
                            >
                                mdi-cloud-upload
                            </v-icon>
                        </v-btn>
                        <v-btn
                            v-if="['reject'].includes(selectedActivity.status)"
                            :loading="loading3"
                            :disabled="loading3"
                            color="yellow darken-3"
                            class="ma-2 white--text"
                            @click="loader = 'loading3'"
                        >
                            Edit
                            <v-icon
                                right
                                dark
                            >
                                mdi-note-edit-outline
                            </v-icon>
                        </v-btn>
                        <v-btn
                            v-if="['save', 'reject'].includes(selectedActivity.status)"
                            :loading="loading3"
                            :disabled="loading3"
                            color="red darken-3"
                            class="ma-2 white--text"
                            @click="loader = 'loading3'"
                        >
                            Delete
                            <v-icon
                                right
                                dark
                            >
                                mdi-delete-circle-outline
                            </v-icon>
                        </v-btn>
                    </div>
                -->

        <div class="text-center">
          <p class="mt-2 mb-0 text--disabled">
            Support By Academic Services Group (กลุ่มบริการวิชาการ)
          </p>
          <p class="mt-0 mb-0 text--disabled">
            Office phone : 02-700-5000 ext. 1241, 1211
          </p>
        </div>
      </v-sheet>
    </v-navigation-drawer>

    <!-- error main page -->
    <v-snackbar absolute top color="red darken-4">
      <!-- <strong>{{ errorMsg }}</strong> -->
    </v-snackbar>
  </div>
</template>

<script>
import graphBarReport from "./academicservice/graphBarReport.vue";
import formEditActivity from "./academicservice/formEditActivity.vue";
import detailSuccess from "./academicservice/detailSuccess.vue";

export default {
  components: {
    graphBarReport,
    formEditActivity,
    detailSuccess,
  },
  data() {
    return {
      search: "",
      dataAcademic: [],
      optionActivityType: [],
      loading: false,
      errorMsgCallData: null,
      years: [],
      selectYear: null,
      //
      search: "",
      showDetail: false,
      selectedActivity: {},
      //
      totalHour: 0,
      totalPoint: 0,
      totalSuccess: 0,
    };
  },
  computed: {
    summaryReportView() {
      return [
        {
          labelView: "Activities",
          SumView: this.totalSuccess,
          remarkView: "All Activities",
          icon: "mdi-checkbox-marked-circle-outline",
          iconColor: "blue darken-1",
          bgClass: "blue lighten-5",
        },
        {
          labelView: "Hours",
          SumView: this.totalHour,
          remarkView: "Total Hours",
          icon: "mdi-clock-outline",
          iconColor: "green darken-1",
          bgClass: "green lighten-5",
        },
        {
          labelView: "Point",
          SumView: this.totalPoint,
          remarkView: "Total 1000 Points (Max.)",
          icon: "mdi-chart-bar",
          iconColor: "orange darken-1",
          bgClass: "orange lighten-5",
        },
      ];
    },
    resolveComponent() {
      const status = this.selectedActivity.status;
      if (["save", "reject"].includes(status)) return "formEditActivity";
      if (["approve", "send"].includes(status)) return "detailSuccess";
      return null;
    },
    headersMain() {
      return [
        {
          sortable: false,
          text: "Title",
          value: "name_academic",
          align: "center",
          class: "font-weight-bold text-h5 blue-grey darken-3 white--text",
        },
        {
          sortable: false,
          text: "Type",
          value: "activityTy",
          align: "center",
          class: "font-weight-bold text-h5 blue-grey darken-3 white--text",
        },
        {
          sortable: false,
          text: "Hours",
          value: "point_activity",
          align: "center",
          class: "font-weight-bold text-h5 blue-grey darken-3 white--text",
        },
        {
          sortable: false,
          text: "Point",
          value: "point_activity",
          align: "center",
          class: "font-weight-bold text-h5 blue-grey darken-3 white--text",
        },
        {
          sortable: false,
          text: "Status",
          value: "status",
          align: "center",
          class: "font-weight-bold text-h5 blue-grey darken-3 white--text",
        },
        {
          sortable: false,
          text: "",
          value: "action",
          align: "center",
          class: "font-weight-bold text-h6 blue-grey darken-3 white--text",
        },
      ];
    },
  },
  watch: {
    selectYear(newVal) {
      this.getActivityList();
    },
  },
  mounted() {
    this.getPeriods();
    this.getActivityType();
  },
  methods: {
    formatDate(date) {
      return date ? this.moment(date).format("DD/MM/YYYY") : "-";
    },
    getAcademicYear(date) {
      if (!date) return "-";
      const d = this.moment(date);
      const year = d.month() >= 7 ? d.year() + 1 : d.year();
      return year;
    },
    getPAYear(date) {
      if (!date) return null;
      const d = this.moment(date);
      // PA fiscal year: July 1 (year-1) to June 30 (year)
      // month() is 0-indexed: 0=Jan,...,6=Jul
      const gregorianYear = d.month() >= 6 ? d.year() + 1 : d.year();
      return gregorianYear + 543;
    },
    getPAYearLabel(date) {
      const paYear = this.getPAYear(date);
      if (!paYear) return "-";
      const startYear = paYear - 1;
      return `${paYear} ( 1 July ${startYear} - 30 June ${paYear} )`;
    },
    getStatusColor(status) {
      switch (status) {
        case "send":
          return "blue darken-2";
        case "save":
          return "amber darken-3";
        case "approve":
          return "green darken-2";
        case "rejected":
          return "red darken-2";
        default:
          return "grey darken-1";
      }
    },
    getStatusAction(status) {
      switch (status) {
        case "send":
          return ["blue darken-2", "mdi-cube-send", ""];
        case "save":
          return ["amber darken-3", "mdi-clock-fast", ""];
        case "approve":
          return ["green darken-2", "mdi-bookmark-check-outline", ""];
        case "rejected":
          return ["red darken-2", "mdi-fire", ""];
        default:
          return ["grey darken-1", "", ""];
      }
    },
    async getPeriods() {
      this.years = [];
      let year = new Date().getFullYear();
      let nextYear = year + 1;
      for (let i = year; i > year - 5; i--) {
        this.years.push({ value: i, text: i.toString() });
      }
      this.years.unshift({ value: nextYear, text: nextYear.toString() });
      this.selectYear = new Date().getFullYear();
    },
    async getActivityType() {
      this.optionActivityType = [];
      try {
        const resType = await this.$http.get(
          `/academic-service/activity-types/`
        );
        if ([200, 201].includes(resType.status)) {
          this.optionActivityType = resType.data
            .filter((a) => a.status === "on")
            .map((item) => {
              return {
                text: `${item.detail} (x${parseFloat(item.point).toFixed(
                  2
                )} Point )`,
                value: item.id,
                ...item,
              };
            });
          // console.log(this.optionActivityType)
        } else {
          throw { resType };
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getActivityList() {
      this.loading = true;
      this.dataAcademic = [];
      this.totalHour = 0;
      this.totalPoint = 0;
      this.totalSuccess = 0;

      try {
        const resData = await this.$http.get(
          `/academic-service/main-activities/?year_academic=${this.selectYear}`
        );

        if ([200, 201].includes(resData.status)) {
          this.dataAcademic = resData.data.map((item) => ({
            ...item,
          }));
          console.log(this.dataAcademic);

          const approvedList = this.dataAcademic.filter(
            (a) => a.status === "approve" // หรือถ้า key เป็นอื่น เช่น a.approved === true ก็เปลี่ยนได้
          );

          this.totalHour = approvedList.reduce(
            (sum, cur) => sum + Number(cur.point_activity || 0),
            0
          );
          this.totalPoint = approvedList.reduce(
            (sum, cur) => sum + Number(cur.point_activity || 0),
            0
          );

          this.totalSuccess = approvedList.length;
          this.loading = false;
        } else {
          throw { resData };
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    openDetail(item) {
      this.selectedActivity = Object.assign({}, item);
      this.showDetail = true;
    },
    closeDetail() {
      this.showDetail = false;
      this.selectedActivity = Object.assign({}, {});
    },
    async onUpdatedActivity(...args) {
      await this.getActivityList();
      this.closeDetail();
      // console.log(args[0])
    },
    async deleteActivity() {
      await this.getActivityList();
      this.closeDetail();
    },
  },
};
</script>

<style scoped>
.summary-stat-card {
  display: flex;
  align-items: center;
  padding: 12px 0;
}

.summary-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 12px;
}

.summary-info {
  display: flex;
  flex-direction: column;
  margin-left: 16px;
  flex: 1;
}

.summary-label {
  font-size: 14px;
  color: #718096;
  font-weight: 400;
}

.summary-value {
  font-size: 22px;
  font-weight: 700;
  color: #2d3748;
}

.summary-remark {
  text-align: right;
  white-space: nowrap;
}
</style>
